import { rtkApi } from 'app/store/AppStore.rtk'
import { SchedulesRequest, SchedulesResponse } from 'types'

export const schedulesApi = rtkApi
  .enhanceEndpoints({
    addTagTypes: ['schedules'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getSchedules: build.query<SchedulesResponse, SchedulesRequest>({
        query: ({ stateId, districtId, schoolId, sportId, isGame, season }: SchedulesRequest) => {
          return {
            url: `/table`,
            params: {
              stateId,
              districtId,
              schoolId,
              sportId,
              season,
              isGame: isGame ? 'true' : 'false',
            },
          }
        },
        providesTags: ['schedules'],
      }),
    }),
  })

export const { useGetSchedulesQuery } = schedulesApi
